module.exports = __webpack_public_path__ + "static/media/coral-1.a0a4b486.png";